import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
//import { Icon } from 'semantic-ui-react';
//import './theoretical-tab.less';
import { SimpleTheoreticalFormAnswerDto } from 'stores/events/theoretical-form-store';
import { CountryFlag } from 'widgets/bussiness/country-flag';

interface TailwindTheoreticalTableProps extends WithTranslation {
  readOnly?: boolean;
  theoreticalFormAnswers: SimpleTheoreticalFormAnswerDto[];
  templateId: string;
  onOpenEmployeeTheoreticalForm: (form: SimpleTheoreticalFormAnswerDto) => void;
  showDeleteConfirmationModal: (form: SimpleTheoreticalFormAnswerDto) => void;
  showResendConfirmationModal: (form: SimpleTheoreticalFormAnswerDto) => void;
  isEventClosed?: boolean;
  userCanDeleteAndResend?: boolean;
}

const TailwindTheoreticalTable: FC<TailwindTheoreticalTableProps> = ({
  t,
  theoreticalFormAnswers,
  onOpenEmployeeTheoreticalForm,
  showDeleteConfirmationModal,
  showResendConfirmationModal,
  userCanDeleteAndResend
}) => {
  return (
    <div onClick={() => {}} className={`w-full bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]`}>
      <div className="mb-3"></div>
      {(theoreticalFormAnswers || []).map((form, idx) => {
        if (!form) return null;
        const { user, id, userId, averageTime, questionsAnswered, result, totalQuestions, totalTime } = form;
        return (
          <div className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h4 className="text-black-600 font-semibold">{`${user.firstName}  ${user.lastName}`}</h4>
                </div>
                <p className="text-xs text-gray-500">{user.userName}</p>
                <p className="text-sm">
                  {user.location ? (
                    <>
                      <CountryFlag countryName={user.location.countryName} />
                      {` ${user.location.location}`}
                    </>
                  ) : (
                    '-'
                  )}
                </p>
                <p className="text-sm">
                  {t('Average Time')}: {averageTime ? averageTime : '-'}
                </p>
                <p className="text-sm">
                  {t('Total Time')}: {totalTime ? totalTime : '-'}
                </p>
                <p className="text-sm">
                  {t('Result')}: {result != null && result !== 0 ? `${result} %` : '-'}
                </p>
                <p className="text-sm">
                  {t('Number of Questions')}:
                  {questionsAnswered == null || questionsAnswered === 0 ? '-' : `${questionsAnswered}/${totalQuestions}`}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <div key={`${idx}_${id}_${userId}_open`} onClick={() => onOpenEmployeeTheoreticalForm(form)}>
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                    <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                </div>

                <div
                  hidden={!userCanDeleteAndResend}
                  key={`${idx}_${id}_${userId}_resend`}
                  onClick={() => showResendConfirmationModal(form)}
                >
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 12H5m14 0-4 4m4-4-4-4"
                    />
                  </svg>
                </div>

                <div
                  hidden={!userCanDeleteAndResend}
                  key={`${idx}_${id}_${userId}_remove`}
                  onClick={() => showDeleteConfirmationModal(form)}
                >
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white cursor-pointer"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default withTranslation()(TailwindTheoreticalTable);
